import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

/**
 * Global sidskelett som visas medan en route laddas.
 * Matchar appens grundlayout (header + verktygsrad + innehåll) så inget hoppar.
 */
const PageLoadingSkeleton: React.FC = () => (
  <div className="min-h-screen bg-background" aria-busy="true" aria-live="polite">
    <span className="sr-only">Laddar sidan…</span>
    <div className="border-b bg-card">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 space-y-3">
        <Skeleton className="h-7 w-64" />
        <Skeleton className="h-4 w-80" />
      </div>
    </div>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 space-y-6">
      <Skeleton className="h-11 w-full rounded-full" />
      <div className="rounded-lg border bg-card p-4 space-y-3">
        <Skeleton className="h-4 w-40" />
        <div className="flex flex-wrap gap-2">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={i} className="h-9 w-24 rounded-full" />
          ))}
        </div>
      </div>
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="rounded-lg border bg-card p-4 space-y-3">
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-3 w-1/3" />
        </div>
      ))}
    </div>
  </div>
);

export default PageLoadingSkeleton;
